export enum SummaryTypes {
	combined = 'Combined',
	activitiesAndWorkers = 'Activities & Workers',
	professionAnalysis = 'Subcontractor Analysis',
}
